/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

var cachedCanvas;
export var getTextWidth = function getTextWidth(text, fontDesc) {
  if (text.length === 0) {
    return 0;
  }
  if (!cachedCanvas) {
    cachedCanvas = document.createElement('canvas');
  }
  var context = cachedCanvas.getContext('2d');
  if (!context) {
    // this is mostly to satisfy typescript, as the possibility
    //  of null context in the real world is slim
    return 0;
  }
  var fontStr = fontDesc.weight.toString() + ' ' + fontDesc.size + 'px ' + fontDesc.family;
  context.font = fontStr;
  var textWidth = context.measureText(text).width;
  if (fontDesc.letterSpacing) {
    textWidth += text.length * fontDesc.letterSpacing;
  }
  return textWidth;
};